<nx-pageTitle-box class="mb-3"
  [label]="'core.jobAdmin.pageTitle.label'"
  [icon]="'icon-time'"
  [iconToolTip]="'core.jobAdmin.pageTitle.label'"
  [bcRootLvlLabel]="'Einstellungen'"
  [bcRootLvlPath]="'settings'">
</nx-pageTitle-box>

<div class="flex flex-row items-center gap-2 mb-3">
  <p-dropdown
    [options]="jobGroups()"
    [ngModel]="selectedGroup()"
    [showClear]="true"
    [appendTo]="'body'"
    [placeholder]="'core.jobAdmin.filters.group' | translate"
    (onChange)="onGroupChange($any($event).value)"
    (onClear)="onGroupChange(null)">
  </p-dropdown>
  <nx-default-button
    [style]="'light'"
    [icon]="'icon-refresh'"
    [tooltip]="'core.jobAdmin.actions.refresh' | translate"
    [disabled]="!selectedGroup()"
    (click)="reload()">
  </nx-default-button>
</div>

@if (!selectedGroup()) {
  <nx-empty-box [label]="'core.jobAdmin.messages.selectGroup'"></nx-empty-box>
} @else if (error()) {
  <div class="bg-white px-5 py-4 text-[#c0123c] border-t border-gray">
    {{ 'core.jobAdmin.messages.loadError' | translate }}
  </div>
} @else if (loading()) {
  <div class="bg-white px-5 py-4 flex flex-row justify-center border-t border-gray">
    <p-progressSpinner [style]="{ width: '2rem', height: '2rem' }" strokeWidth="4"></p-progressSpinner>
  </div>
} @else {
  <p-table [value]="rows()">
    <ng-template pTemplate="header">
      <tr>
        <th>{{ 'core.jobAdmin.jobTable.name' | translate }}</th>
        <th>{{ 'core.jobAdmin.jobTable.group' | translate }}</th>
        <th>{{ 'core.jobAdmin.jobTable.jobClass' | translate }}</th>
        <th>{{ 'core.jobAdmin.jobTable.description' | translate }}</th>
        <th>{{ 'core.jobAdmin.jobTable.nextExecution' | translate }}</th>
        <th>{{ 'core.jobAdmin.jobTable.status' | translate }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
      <tr class="clickable" (click)="openJob(row.job)">
        <td>{{ row.job.key?.name }}</td>
        <td>{{ row.job.key?.group }}</td>
        <td>{{ row.job.jobClass }}</td>
        <td>{{ row.job.description }}</td>
        <td>{{ row.nextExecution | formatFutureRelativeTime }}</td>
        <td><app-trigger-state-badge [state]="row.status"></app-trigger-state-badge></td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="6" class="emptyMessage">{{ 'core.jobAdmin.jobTable.emptyMessage' | translate }}</td>
      </tr>
    </ng-template>
  </p-table>
}
